import request from "../utils/request";

export function POST_AuthAdminLogin(payload) {
  return request.post("/Auth/Login", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function GET_AuthFunction(token, payload) {
  return request.get("/Auth/Function", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_AdminList(token) {
  return request.get("/Auth/Admin/List", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Admin(token, payload) {
  return request.post("/Auth/Admin", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function PUT_Admin(token, payload) {
  return request.put("/Auth/Admin", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Admin(token, payload) {
  return request.delete("/Auth/Admin", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function PUT_Password(token, payload) {
  return request.put("/Auth/Password", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

/* 忘記密碼／重設密碼是匿名端點：使用者就是因為進不去才要用這兩支，不能帶 token */
export function POST_ForgotPassword(payload) {
  return request.post("/Auth/Password/Forgot", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function POST_ResetPassword(payload) {
  return request.post("/Auth/Password/Reset", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
